import { apiGet } from '../utils/api'

export const getPluginsListAPI = () => {
  return apiGet('plugins/list')
}



// WEBPACK FOOTER //
// ./src/api/plugins.js